import { colorStrings, fontFamily, fontFamilyHeader, mediaQueriesBP } from "@iewccouk/Utilities/variables";
import baseTheme, { ThemeTypography } from "@insite/mobius/globals/baseTheme";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

export const headingCommon: TypographyPresentationProps = {
    fontFamily: fontFamilyHeader,
    lineHeight: "normal",
    weight: 700,
    color: colorStrings.textMain,
    transform: "none",
    mergeCss: true,
};

export const bodyCommon: TypographyPresentationProps = {
    fontFamily,
    size: "16px",
    lineHeight: "26px",
    weight: 400,
    color: colorStrings.textMain,
    transform: "none",
    mergeCss: true,
};

export const typography: ThemeTypography & { bodyBig: TypographyPresentationProps } = {
    h1: {
        ...baseTheme.typography.h1,
        ...headingCommon,
        size: "38px",
        lineHeight: "44px",
        css: css`
            ${baseTheme.typography.h1.css}
            ${mediaQueriesBP.maxMD} {
                font-size: 32px;
                line-height: 38px;
            }
        `,
    },
    h2: {
        ...baseTheme.typography.h2,
        ...headingCommon,
        size: "32px",
        lineHeight: "38px",
        css: css`
            ${baseTheme.typography.h2.css}
            ${mediaQueriesBP.maxMD} {
                font-size: 29px;
                line-height: 35px;
            }

            /* Overwriting Page title markup style as h1 */
            &[data-test-selector="PageTitle"] {
                font-size: 32px;
                line-height: 38px;
                ${mediaQueriesBP.minMD} {
                    font-size: 38px;
                    line-height: 44px;
                }
            }
        `,
    },
    h3: {
        ...baseTheme.typography.h3,
        ...headingCommon,
        size: "29px",
        lineHeight: "35px",
        css: css`
            ${baseTheme.typography.h3.css}
            ${mediaQueriesBP.maxMD} {
                font-size: 24px;
                line-height: 30px;
            }
        `,
    },
    h4: {
        ...baseTheme.typography.h4,
        ...headingCommon,
        size: "24px",
        lineHeight: "30px",
        css: css`
            ${baseTheme.typography.h4.css}
            ${mediaQueriesBP.maxMD} {
                font-size: 16px;
                line-height: 19.2px;
            }
        `,
    },
    h5: {
        ...baseTheme.typography.h5,
        ...headingCommon,
        size: "21px",
        lineHeight: "27px",
        css: css`
            ${baseTheme.typography.h5.css}
            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
                line-height: 16.8px;
            }
        `,
    },
    h6: {
        ...baseTheme.typography.h6,
        ...headingCommon,
        size: "18px",
        lineHeight: "26px",
        css: css`
            ${baseTheme.typography.h6.css}
            ${mediaQueriesBP.maxMD} {
                font-size: 16px;
                line-height: 19.2px;
            }
        `,
    },
    headerPrimary: {
        ...baseTheme.typography.headerPrimary,
        ...headingCommon,
    },
    headerSecondary: {
        ...baseTheme.typography.headerSecondary,
        ...headingCommon,
    },
    headerTertiary: {
        ...baseTheme.typography.headerTertiary,
        ...headingCommon,
    },
    body: {
        ...baseTheme.typography.body,
        ...bodyCommon,
    },
    p: {
        ...baseTheme.typography.p,
        ...bodyCommon,
        css: css`
            ${baseTheme.typography.p.css}
        `,
    },
    legend: {
        ...baseTheme.typography.legend,
        ...bodyCommon,
        size: "12px",
        lineHeight: "16px",
    },

    /* Verndale Custom Typography */
    bodyBig: {
        ...baseTheme.typography.body,
        ...bodyCommon,
        size: "18px",
        lineHeight: "24px",
        css: css`
            ${baseTheme.typography.body.css}
            ${mediaQueriesBP.maxMD} {
                font-size: 16px;
                line-height: 20px;
            }
        `,
    },
};
